module.exports = __webpack_public_path__ + "static/img/边框12.945c03d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框12.svg
// module id = hrvn
// module chunks = 2